import { render, staticRenderFns } from "./LanguagesAndSkills.vue?vue&type=template&id=70a4ea07&"
import script from "./LanguagesAndSkills.vue?vue&type=script&lang=js&"
export * from "./LanguagesAndSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports